// ===== MINICART DTO FUNCTIONS ===== //


const addToCart = async (id) => {
  const productId = parseInt(id);

  let productObj = {
    items: [
      {
        id: productId,
        quantity: 1,
      },
    ],
  };

  const response = await addItemToCart(productObj);

  if (response && response.ok) {
    await updateMiniCartInFront(true);
    openMinicart();
  }
};

const removeItemFromCart = async (id) => {
  try {
    const res = await deleteItemFromCart({
      id: id,
      quantity: 0,
    });
    if (res.ok) {
      updateMiniCartInFront();
    }
  } catch (error) {
    console.error("Erro ao remover itens do carrinho:", error);
  }
};

// const updateMinicartItems = async (id, quantity) => {
//   const updates = {
//     id: id,
//     quantity: quantity,
//   };
//   try {
    
//     const res = await updateMinicartQuantity(updates);
//     if (res.ok) {
//       updateMiniCartInFront();
//     }
//   } catch (error) {
//     console.error("Erro ao atualizar itens do carrinho:", error);
//   }
// };

const updateMinicartItems = async (id, quantity) => {
  const updateCartUrl = "/cart/update.js";

  const updates = {
    [id]: parseInt(quantity),
  };

  try {
    const response = await fetch(updateCartUrl, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({ updates }),
    });

    if (response.ok) {
      updateMiniCartInFront();
    }
  } catch (error) {
    console.error(error);
  }
};


const updateMiniCartInFront = async (callGiftFunction = false) => {
  try {
    const response = await getMinicartToUpdateInFront();

    if (response.ok) {
      response.text().then((res) => {
        const divHtml = document.createElement("div");
        divHtml.innerHTML = res;

        const box_items = divHtml.querySelector("#main-minicart").innerHTML;
        document.querySelector("#main-minicart").innerHTML = box_items;

        const items_count = divHtml.querySelector(
          ".minicart-items-count"
        ).innerText;
        document.querySelector(
          "#toggle-minicart .minicart-items-count"
        ).innerText = items_count;

        // actionsButtonsMinicart();

        let cepInputMinicart = document.querySelector("#cep-calc-minicart");
        let discountCodeInput = document.querySelector("#discount-code-input");
        let applyBtn = document.querySelector("#apply-discount-btn");

        if(document.getElementById("cep-calc-minicart")) {
          document.getElementById("cep-calc-minicart").addEventListener("keypress", function (event) {
            if (event.key === "Enter") {
              event.preventDefault();
              calculateShippingMinicart();
            }
          });
          
        }
          


      });

   


    }
  } catch (error) {
    console.error("Erro ao pegar minicart", error);
  }




};
// ===== MINICART DTO FUNCTIONS ===== //
const handleSelectedVariant = (input) => {
  const idVariant = input.value;
  
  // ADD VARIANT ID TO BUY BUTTON
  input
    .closest(".buy-area")
    .querySelector("button")
    .setAttribute("data-id", idVariant);

  removeOldSelectionVariant();

  input.nextElementSibling.setAttribute("data-selected-variant", true);
};
 
const removeOldSelectionVariant = () => {
  document
    .querySelectorAll("input[name='Tamanho']")
    .forEach((el) =>
      el.nextElementSibling.removeAttribute("data-selected-variant")
    );
}


function openMinicart() {
  document.querySelector(".overlay-bg").classList.add("active");
  document.querySelector("#main-minicart").classList.add("active");
}

function closeMinicart() {
  document.querySelector(".overlay-bg").classList.remove("active");
  document.querySelector("#main-minicart").classList.remove("active");
}

const stepUpInput = (element, id, qtd) => {
  const quantity = parseInt(qtd) + 1;
  const input = element.previousElementSibling;
  input.stepUp();

  
  updateMinicartItems(id, quantity);
};
const stepDownInput = (element, id, qtd) => {
  const quantity = parseInt(qtd) - 1;
  const input = element.nextElementSibling;
  input.stepDown();

  if (!quantity <= 0) updateMinicartItems(id, quantity);
};

document.addEventListener("DOMContentLoaded", function () {
  let cepInputMinicart = document.querySelector("#cep-calc-minicart");
    document.getElementById("cep-calc-minicart").addEventListener("keypress", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        calculateShippingMinicart();
      }
    });
  
})

// function handleDiscount() {    
//   let clearBtn = document.querySelector("#clear-discount-btn");
//   let applyBtn = document.querySelector("#apply-discount-btn");
//   let discountCodeError = document.querySelector("#discount-code-error");
//   let discountCodeWrapper = document.querySelector(
//     "#applied-discount-code .applied-discount-code-wrapper"
//   );
//   let discountCodeValue = document.querySelector(
//     "#applied-discount-code .applied-discount-code-value"
//   );
//   let discountCodeInput = document.querySelector("#discount-code-input");
//   let totalCartSelector = document.querySelector(".cart__subtotal .money");
//   let authorization_token;

//   let checkoutContainer = document.createElement("div");
//   document.body.appendChild(checkoutContainer);
//   if (localStorage.discountCode)
//     applyDiscount(JSON.parse(localStorage.discountCode).code);
//   if (applyBtn)
//     applyBtn.addEventListener("click", function (e) {
//       e.preventDefault();
//       applyDiscount(discountCodeInput.value);
//     });
//   if (clearBtn)
//     clearBtn.addEventListener("click", function (e) {
//       e.preventDefault();
//       clearDiscount();
//     });

//   function clearDiscount() {
//     discountCodeValue.innerHTML = "";
//     discountCodeError.innerHTML = "";
//     clearLocalStorage();
//     fetch("/discount/CLEAR");
//   }

//   function clearLocalStorage() {
//     if (discountCodeWrapper) discountCodeWrapper.style.display = "none";
//     if (totalCartSelector)
//       totalCartSelector.innerHTML = JSON.parse(
//         localStorage.discountCode
//       ).totalCart;
//     localStorage.removeItem("discountCode");
//   }

//   // function applyDiscount(code) {
//   //   if (applyBtn) {
//   //     applyBtn.innerHTML =
//   //       "<span class='flex items-center gap-2 justify-center'>Aplicando <div class='loader animate-spinFast border-5 border-gray-200 border-t-4 border-t-black rounded-full w-[15px] h-[15px] animate-spin'></div></span>";
//   //     applyBtn.style.pointerEvents = "none";
//   //   }
//   //   fetch("/payments/config", { method: "GET" })
//   //     .then(function (response) {
//   //       return response.json();
//   //     })
//   //     .then(function (data) {
//   //       const checkout_json_url = "/wallets/checkouts/";
//   //       authorization_token = btoa(data.paymentInstruments.accessToken);
//   //       fetch("/cart.js", {})
//   //         .then(function (res) {
//   //           return res.json();
//   //         })
//   //         .then(function (data) {
//   //           let body = {
//   //             checkout: {
//   //               country: Shopify.country,
//   //               discount_code: code,
//   //               line_items: data.items,
//   //               presentment_currency: Shopify.currency.active,
//   //             },
//   //           };
//   //           fetch(checkout_json_url, {
//   //             headers: {
//   //               accept: "*/*",
//   //               "cache-control": "no-cache",
//   //               authorization: "Basic " + authorization_token,
//   //               "content-type": "application/json, text/javascript",
//   //               pragma: "no-cache",
//   //               "sec-fetch-dest": "empty",
//   //               "sec-fetch-mode": "cors",
//   //               "sec-fetch-site": "same-origin",
//   //             },
//   //             referrerPolicy: "strict-origin-when-cross-origin",
//   //             method: "POST",
//   //             mode: "cors",
//   //             credentials: "include",
//   //             body: JSON.stringify(body),
//   //           })
//   //             .then(function (response) {
//   //               return response.json();
//   //             })
//   //             .then(function (data) {
//   //               if (
//   //                 data.checkout &&
//   //                 data.checkout.applied_discounts.length > 1
//   //               ) {
//   //                 let discountApplyUrl =
//   //                   "/discount/" +
//   //                   code +
//   //                   "?v=" +
//   //                   Date.now() +
//   //                   "&redirect=/checkout/";
//   //                 fetch(discountApplyUrl, {}).then(function (response) {
//   //                   return response.text();
//   //                 });
//   //                 if (discountCodeWrapper)
//   //                   discountCodeWrapper.style.display = "inline";
//   //                 if (discountCodeError) discountCodeError.innerHTML = "";
//   //                 if (discountCodeValue)
//   //                   discountCodeValue.innerHTML =
//   //                     data.checkout.applied_discounts[1].title +
//   //                     " (" +
//   //                     "R$" +
//   //                     data.checkout.applied_discounts[1].amount +
//   //                     ")";
//   //                 let localStorageValue = {
//   //                   code: code.trim(),
//   //                   totalCart: data.checkout.total_line_items_price,
//   //                 };
//   //                 localStorage.setItem(
//   //                   "discountCode",
//   //                   JSON.stringify(localStorageValue)
//   //                 );
//   //                 if (totalCartSelector)
//   //                   totalCartSelector.innerHTML =
//   //                     "<s>" +
//   //                     data.checkout.total_line_items_price +
//   //                     "</s>" +
//   //                     data.checkout.total_price;
//   //               } else {
//   //                 if (discountCodeValue) discountCodeValue.innerHTML = "";
//   //                 clearLocalStorage();
//   //                 if (discountCodeError)
//   //                   discountCodeError.innerHTML = "Insira um cupom valido.";
//   //               }
//   //             })
//   //             .finally(function (params) {
//   //               if (applyBtn) {
//   //                 applyBtn.innerHTML = "Aplicar";
//   //                 applyBtn.style.pointerEvents = "all";
//   //               }
//   //             });
//   //         });
//   //     });
//   // }

// }

// handleDiscount();

function calculateShippingMinicart() {
  let cep = document.querySelector("#cep-calc-minicart").value.replace("-", "");
  fetch(`https://viacep.com.br/ws/${cep}/json/`)
    .then((response) => response.json())
    .then((resProvince) => {
      if (resProvince.erro) {
        alert("CEP inválido");
        return;
      }

      document.querySelector("#shipping-calc-btn").innerHTML="Calculando...";

      const estados = {
        AC: "Acre",
        AL: "Alagoas",
        AP: "Amapá",
        AM: "Amazonas",
        BA: "Bahia",
        CE: "Ceará",
        DF: "Distrito Federal",
        ES: "Espírito Santo",
        GO: "Goiás",
        MA: "Maranhão",
        MT: "Mato Grosso",
        MS: "Mato Grosso do Sul",
        MG: "Minas Gerais",
        PA: "Pará",
        PB: "Paraíba",
        PR: "Paraná",
        PE: "Pernambuco",
        PI: "Piauí",
        RJ: "Rio de Janeiro",
        RN: "Rio Grande do Norte",
        RS: "Rio Grande do Sul",
        RO: "Rondônia",
        RR: "Roraima",
        SC: "Santa Catarina",
        SP: "São Paulo",
        SE: "Sergipe",
        TO: "Tocantins",
      };

      const shippingData = {
        zip: cep,
        country: "Brazil",
        province: estados[resProvince.uf],
      };

      createShippingRatesMinicart(shippingData);
    })
    .catch((error) => console.error(error));
}

function createShippingRatesMinicart(shippingData) {
  const urlPrepare = "/cart/prepare_shipping_rates.json";
  const requestData = new URLSearchParams({
    "shipping_address[zip]": shippingData.zip,
    "shipping_address[country]": shippingData.country,
    "shipping_address[province]": shippingData.province,
  });

  fetch(urlPrepare, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: requestData,
  })
    .then((response) => {
      if (response.ok) {
        getShippingRatesMinicart(shippingData);
      } else {
        console.error(response.statusText);
      }
    })
    .catch((error) => console.error(error));
}

function getShippingRatesMinicart(shippingData) {
  const urlAsync = `/cart/shipping_rates.json?shipping_address[zip]=${shippingData.zip}&shipping_address[country]=Brazil&shipping_address[province]=${shippingData.province}`;

  fetch(urlAsync)
    .then((response) => response.json())
    .then((result) => {
      console.log(result);
      
      if (result.shipping_rates) {
        createShippingTableMinicart(result.shipping_rates);
      }
    })
    .catch((error) => console.error(error));
}

async function createShippingTableMinicart(shippingRates) {
  document.querySelector("#shipping-calc-btn").innerHTML="Calcular";
  const shippingArea = document.getElementById("shipping-area-minicart");
  shippingArea.innerHTML = "";

  const cartData = await fetch('/cart.js', {
    headers: {
      Accept: 'application/json',
    },
  }).then((response) => response.json());
  const cartTotal = cartData.total_price / 100;

  if (shippingRates && shippingRates.length > 0) {
    const element = document.createElement("div");
    element.className = "shipping-table mt-4 rounded w-full border border-[#cecece] px-4 py-[.3rem]";
    shippingRates.forEach((rate) => {
      let nameShipping = rate.name === "Local Delivery" ? rate.description : rate.name;
      let deliveryDays = rate.delivery_days[0]? ` <p class="text-xs"> Em até ${rate.delivery_days[0]} dias úteis</p>` : ` <p class="text-xs">${rate.description}</p>`;
      const cell = document.createElement("div");
      cell.className = "shipping-line py-4 border-b border-[#cecece]";
      cell.innerHTML = `
        <div class="">
          <p class="font-bold mb-2">${nameShipping}</p>
          <div class="flex items-center justify-between">
            ${deliveryDays}
            <p class="text-xs"> ${rate.price.replace(".", ",")}</p>
          </div>
        </div>
      `;
      element.appendChild(cell);
    });

    shippingArea.appendChild(element);
  } else {
    const noShippingMessage = document.createElement("p");
    noShippingMessage.className = "no-shipping-message";
    noShippingMessage.textContent =
      "Nenhuma opção de frete disponível para o CEP informado.";
    shippingArea.appendChild(noShippingMessage);
  }
}

async function handleAddDiscountCode(discountCode) {
  document.querySelector("#apply-discount-btn").innerHTML = "Aplicando..."
  const clear = await fetch(`/discount/CLEAR`);
  const req = await fetch(`/discount/${discountCode}`);
  await updateMiniCartInFront(); 

  setTimeout(() => {
    const element_when_discount_is_valid = document.querySelector("#applied-discount-code");
  
    if(!element_when_discount_is_valid){
      document.querySelector("#discount-code-error").classList.remove("hidden");
    } else {
      document.querySelector("#discount-code-input").value = discountCode;
      
    }
  },600)
}
async function handleRemoveDiscountCode() {
  const req = await fetch(`/discount/CLEAR`);
  await updateMiniCartInFront();
  document.querySelector("#discount-code-error").classList.add("hidden");
}